/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Not_External_UserInputs */

const en_error_not_external_user = /** @type {(inputs: Error_Not_External_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user signs in with the group's single sign-on, not with a password of Nexxt.`)
};

/**
* | output |
* | --- |
* | "This user signs in with the group's single sign-on, not with a password of Nexxt." |
*
* @param {Error_Not_External_UserInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_not_external_user = /** @type {((inputs?: Error_Not_External_UserInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Not_External_UserInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_not_external_user(inputs)
});